import React, { memo } from 'react';
import classNames from 'classnames';
import './index.less';

export interface IABSFieldTitleProps {
  title?: React.ReactNode | string;
  className?: string;
  required?: boolean;
  textClassName?: string;
  labelWidth?: string | number;
  removePaddingLeft?: boolean;
  isVertical?: boolean;
}

const ABSFieldTitle: React.FC<IABSFieldTitleProps> = props => {
  const {
    title,
    labelWidth = 'auto',
    required,
    className,
    textClassName,
    removePaddingLeft,
    isVertical
  } = props;

  if (title === undefined) {
    return null;
  }

  const renderStar = required ? (
    <span className="abs-field-title-star">*</span>
  ) : null;

  const classes = classNames(
    'abs-field-title',
    { 'remove-padding-left': removePaddingLeft },
    { 'title-vertical': isVertical },
    className
  );

  const textClazzName = classNames('abs-field-title-text', textClassName);
  return (
    <div className={classes}>
      {renderStar}
      <span className={textClazzName} style={{ width: labelWidth }}>
        {title}
      </span>
    </div>
  );
};

export default memo(ABSFieldTitle);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSField/Title/index.tsx